import React, {useState, useRef, useEffect} from 'react';
import {SURVEY_PAGES} from "../JobSurveyPage";
import Card from "../../components/Card";
import axios from "axios";
import {toast} from "react-toastify";
import {format, parse} from "date-fns";
import {DATE_FORMATS} from "../../constants/DateFormats";
import DeleteSurveyImageModal from "../../modals/DeleteSurveyImageModel";


const JobSurveyShowPage = (props) => {
    const {
        jobId           = null,
        surveyId        = null,
        onChangePage    = (INDEX, survey) => {}
    } = props;

    const [survey, setSurvey] = useState(null);
    const [deleteSurveyOrderModal, setDeleteSurveyOrderModal] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [fileId, setFileId] = useState(null);

    useEffect(() => {
        if (!!surveyId) {
            load();
        }
    }, [surveyId]);

    const load = () => {
        axios.get(route('web-api.job.survey.config', {job: jobId, survey_id: surveyId}).toString())
            .then((response) => {
                if (!!response && !!response.data) {

                    if (!!response.data.survey) {
                        setSurvey(response.data.survey);
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(<div>{"An error occurred"}</div>);
            });
    }

    const reset = () => {
        setSurvey(null);
    }

    const handleClickBack = (event) => {
        event.preventDefault();
        reset();
        onChangePage(SURVEY_PAGES.INDEX, null);
    }

    const renderDate = (dateString) => {
        return format(parse(dateString, DATE_FORMATS.DB, new Date()), DATE_FORMATS.DATE_HM_DASH);
    }

    const renderSurveyImages = () => {
        return (
            <div className={"image-row"}>
                {!!survey && !!survey.images && survey.images.length > 0 && survey.images.map((image) => {
                    let content = null;
                    if (image.type === "image") {
                        content = (
                            <img src={image.url} alt={image.name} title={image.name} className={"image"} />

                        );
                    } else {
                        content = (
                            <div className={"placeholder"} title={image.name}>Click To Open</div>
                        );
                    }

                    return (
                        <div className="relative mr-2">
                            <a href={image.url} target={"_blank"} className={"d-block mb-2"}>
                                {content}
                            </a>
                            <div className={"absolute top-2 right-2 rounded-button cursor-pointer"}
                                onClick={() => {
                                setFileId(image.id)
                                setFileName(image.name)
                                setDeleteSurveyOrderModal(true)
                                }}
                            >
                                <span>x</span>
                            </div>
                        </div>
                    );
                })}

                    <DeleteSurveyImageModal
                        show={!!deleteSurveyOrderModal}
                        file_id={fileId}
                        file_name={fileName}
                        job_id={jobId}
                        survey_id={survey.id}
                        onCancel={() => setDeleteSurveyOrderModal(false)}
                        onComplete={(fileName) => {
                            setDeleteSurveyOrderModal(false)
                            window.location.reload();
                        }}
                    />
            </div>


        )
    }

    return (
        <React.Fragment>
            <Card
                title={"Survey Details"}
                classes={"mh-100 border-0"}
                controls={can('viewAny', 'survey') ? (
                    <button
                        onClick={(event) => handleClickBack(event)}
                        className={"btn font-weight-bold btn-outline-eh-off-black px-4 m-0"}
                    >
                        <i className={"fa fa-chevron-left mr-2"} />
                        <span>{"Back"}</span>
                    </button>
                ) : null}
            >
                <div className="row m-0 p-0 bg-eh-lightest-grey border border-eh-mid-grey rounded">
                    <div className="col-12 m-0 p-4">
                        <div className="row m-0 p-0">
                            <div className={"col-12 col-md-6 col-lg-4 m-0 p-0 pr-md-2"}>
                                <p className="mb-0 text-eh-off-black"><strong>Survey Created</strong></p>
                                <p className="text-eh-off-black">{!!survey && !!survey.created_at ? renderDate(survey.created_at) : "-"}</p>
                            </div>
                            <div className={"col-12 col-md-6 col-lg-4 m-0 p-0 pl-md-2 px-lg-2"}>
                                <p className="mb-0 text-eh-off-black"><strong>Surveyor</strong></p>
                                <p className="text-eh-off-black">{!!survey && !!survey.surveyor && !!survey.surveyor.name ? survey.surveyor.name : "-"}</p>
                            </div>
                            <div className={"col-12 col-md-6 col-lg-4 m-0 p-0 pr-md-2 pl-lg-0 pr-lg-2"}>
                                <p className="mb-0 text-eh-off-black"><strong>Survey Completed</strong></p>
                                <p className="text-eh-off-black">{!!survey && !!survey.completed_at ? renderDate(survey.completed_at) : "-"}</p>
                            </div>
                        </div>
                        <div className="row m-0 p-0">
                            <div className="col-12 m-0 p-0">
                                <p className="mb-0 text-eh-off-black"><strong>Status</strong></p>
                                <p className="text-eh-off-black">{!!survey && !!survey.status ? survey.status : "-"}</p>
                            </div>
                        </div>
                        <div className="row m-0 p-0">
                            <div className="col-12 m-0 p-0">
                                <p className="mb-0 text-eh-off-black"><strong>Notes</strong></p>
                                <p className="text-eh-off-black">{!!survey && !!survey.admin_notes ? survey.admin_notes : "-"}</p>
                            </div>
                        </div>
                        <div className="row m-0 p-0">
                            <div className="col-12 m-0 p-0">
                                <p className="mb-0 text-eh-off-black"><strong>Surveyor Notes</strong></p>
                                <p className="text-eh-off-black">{!!survey && !!survey.surveyor_notes ? survey.surveyor_notes : "-"}</p>
                            </div>
                        </div>
                        <div className="row m-0 p-0">
                            <div className="col-12 m-0 p-0">
                                <p className={!!survey && !!survey.images && (survey.images.length > 0) ? "mb-2 text-eh-off-black" : "mb-0 text-eh-off-black"}><strong>Surveyor Photos</strong></p>
                                {!!survey && !!survey.images && (survey.images.length > 0) ? renderSurveyImages() : "-"}
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        </React.Fragment>
    );
}

export default JobSurveyShowPage;
